module.exports = __webpack_public_path__ + "img/microphone.4ebed97a.png";